import React from 'react';
import {
  calculateEndTime,
  formatTime,
  getEventDisplayTag,
  getEventTypeMeta,
} from '../../utils/calendarHelpers';

function CalendarEventCard({ event }) {
  const typeMeta = getEventTypeMeta(event);
  const tag = getEventDisplayTag(event);
  const endTime = calculateEndTime(event.time, event.duration || 60);
  const timeLabel =
    event.time && endTime ? `${formatTime(event.time)} - ${endTime}` : formatTime(event.time);

  return (
    <article className={`calendar-event-card calendar-event-card--${tag.id}`}>
      <div className="calendar-event-card__icon" aria-hidden="true">
        {typeMeta.icon}
      </div>
      <div className="calendar-event-card__body">
        {timeLabel ? <p className="calendar-event-card__time">{timeLabel}</p> : null}
        <h4 className="calendar-event-card__title">{event.title}</h4>
        <span className={`calendar-event-tag calendar-event-tag--${tag.id}`}>
          {tag.label}
        </span>
      </div>
    </article>
  );
}

export default CalendarEventCard;
